<template>
    <div>
        <div class="card-header">
            Send payment to talent
        </div>
        <div class="card-body">
            <p class="invoice-state-description">
                The following payment should be made to the talent:
            </p>
            <table class="table table-striped">
                <tbody>
                <tr>
                    <th>Received Payment</th>

                    <th> {{ receivedPayment | formatCurrency(currency) }}</th>
                </tr>
                <tr>
                    <th></th>
                    <td></td>
                </tr>
                <tr>
                    <th>Charge Fee ({{ chargeFee }}%)</th>
                    <td>-{{ chargeFeeAmount | formatCurrency(currency) }}</td>
                </tr>
                <tr>
                    <th>Employee Fee ({{ employeeFee }}%)</th>
                    <td>-{{ employeeFeeAmount | formatCurrency(currency) }}</td>
                </tr>
                <tr>
                    <th>Brutto</th>
                    <th>{{ bruttoSalary | formatCurrency(currency) }}</th>
                </tr>
                <tr>
                    <th></th>
                    <td></td>
                </tr>
                <tr>
                    <th>Tax ({{ taxPercentage }}%)</th>
                    <td>-{{ taxAmount | formatCurrency(currency) }}</td>
                </tr>
                <tr class="summary">
                    <th>To be paid (Netto)</th>
                    <th>{{ nettoSalary | formatCurrency(currency) }}</th>
                </tr>
                </tbody>
            </table>

            <div class="row">
                <div class="col-md-6">
                    <confirm-toggle v-model="accepted" :label="toggleLabel"></confirm-toggle>
                </div>
                <div class="col-md-6">
                    <button type="submit" class="btn btn-primary btn-block" @click.prevent="accept"
                            :disabled="!accepted">Mark as payment sent
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import DefaultState from './DefaultState';

  export default {
    name: 'PaymentReceived',
    extends: DefaultState,
    data() {
      return {
        accepted: false,
      };
    },

    computed: {
      toggleLabel() {
        const salary = new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.currency }).format(this.nettoSalary);
        return `I have created a payment of ${salary} ${this.currency} to the talent`;
      },

      receivedPayment() {
        return this.invoice.received_payment.amount;
      },

      employeeFee() {
        return 31.42;
      },
      employeeFeeRatio() {
        return 1.3142;
      },
      employeeFeeAmount() {
        return this.amountToSend - this.bruttoSalary;
      },

      chargeFee() {
        return this.invoice.charge_fee;
      },
      feeRatio() {
        return 1 - (this.chargeFee / 100);
      },
      chargeFeeAmount() {
        return this.receivedPayment - this.amountToSend;
      },

      taxPercentage() {
        return this.invoice.tax;
      },
      taxRatio() {
        return this.taxPercentage / 100;
      },
      taxAmount() {
        return this.bruttoSalary - this.nettoSalary;
      },

      amountToSend() {
        return this.receivedPayment * this.feeRatio;
      },
      bruttoSalary() {
        return this.amountToSend / this.employeeFeeRatio;
      },
      nettoSalary() {
        return this.bruttoSalary * (1 - this.taxRatio);
      },
      currency() {
        return this.invoice.received_payment.currency;
      },

    },
    methods: {
      accept() {
        this.action({transition: this.getTransition('PaymentSent')});
      },

    },
  };
</script>

<style scoped>
    .form-check.invoice {
        margin-top: 0px;
    }

    tr.summary th, tr.summary td {
        font-size: 0.9em;
    }
</style>
